// ─────────────────────────────────────────────────────────────────────────
//  THE ONE FILE A NEW GAME EDITS FIRST.
//
//  Set GAME_ID to the game's id (lowercase, digits, hyphens — e.g. "neon-rider").
//  Every localStorage key, custom-event name and cache name in the shell is
//  derived from it, so two games never collide even on the same origin.
// ─────────────────────────────────────────────────────────────────────────

export const GAME_ID = "board-othellos";

/** `${GAME_ID}.<name>` — localStorage key namespace. */
export const key = (name: string): string => `${GAME_ID}.${name}`;

/** `${GAME_ID}:<name>` — window CustomEvent name namespace. */
export const evt = (name: string): string => `${GAME_ID}:${name}`;
